import React from 'react';
import { useParams } from 'react-router-dom';
import { FlagOutlined } from '@ant-design/icons';

import SingleOption from './options/single-option';
import MultiOption from './options/multi-option';
import JudgeOption from './options/judge-option';
import CompletionOption from './options/completion-option';
import AnswerOption from './options/answer-option';
import { submitExamAnswer, addFlag, removeFlag } from '../api';
import { QuestionListItem, QuestionItem, OptionItem } from '../types';
import { message } from 'antd';

interface IProps {
  textFontSize: number;
  questionList: QuestionListItem[];
  setQuestionList: (data: QuestionListItem[]) => void;
}

function QuestionList({ textFontSize, questionList, setQuestionList }: IProps) {
  const urlParams: { id: string, type: 'see' | 'review' } = useParams();
  console.log('type:', urlParams.type);

  function computedCount(data: QuestionItem[]): number {
    let totalCount = 0;
    data.map(item => {
      totalCount += item.grade;
    })
    return totalCount;
  }

  function renderOptions(firstIndex: number, secondIndex: number, type: number, ques: QuestionItem) {
    const { options, myAnswer } = ques;
    if (type === 1) {
      return (<SingleOption
        firstIndex={firstIndex}
        secondIndex={secondIndex}
        myAnswer={myAnswer}
        options={options}
        singleClick={singleClick}
      />)
    }
    if (type === 2) {
      return (<MultiOption
        firstIndex={firstIndex}
        secondIndex={secondIndex}
        myAnswer={myAnswer}
        options={options}
        singleClick={singleClick}
      />)
    }
    if (type === 3) {
      return (<JudgeOption
        firstIndex={firstIndex}
        secondIndex={secondIndex}
        myAnswer={myAnswer}
        options={options}
        singleClick={singleClick}
      />)
    }
    if (type === 4) {
      return <CompletionOption
        firstIndex={firstIndex}
        secondIndex={secondIndex}
        myAnswer={myAnswer}
        fillAnswer={fillAnswer}
        options={options}
      />
    }
    const currQuestion = questionList[firstIndex].questions[secondIndex];
    if (type === 5) {
      return (<AnswerOption
        firstIndex={firstIndex}
        secondIndex={secondIndex}
        myAnswer={myAnswer}
        questionItem={currQuestion}
        handleAnswer={handleAnswer}
      />)
    }

    return null;
  }

  function singleClick(firstIndex: number, secondIndex: number, data: OptionItem[]) {
    let newData = [...questionList];
    const { questionType } = newData[firstIndex];
    const { id } = newData[firstIndex].questions[secondIndex];
    let answer: string[] = [];
    data.map(item => {
      if (item.tag === 1) {
        answer.push(item.id);
      }
    })
    newData[firstIndex].questions[secondIndex].options = data;
    newData[firstIndex].questions[secondIndex].myAnswer = answer;
    const params = {
      examID: urlParams.id,
      questionType,
      questionID: id,
      answer
    };
    setQuestionList(newData);
    handleSubmitAnswer(params);
  }

  function fillAnswer(firstIndex: number, secondIndex: number, data: OptionItem[], isSubmit: boolean) {
    let newData = [...questionList];
    const { questionType } = newData[firstIndex];
    const { id } = newData[firstIndex].questions[secondIndex];
    newData[firstIndex].questions[secondIndex].options = data;
    let answer: string[] = [];
    if (isSubmit) {
      data.map(item => {
        answer.push(item.blankAnswer || '');
        return item;
      })
      newData[firstIndex].questions[secondIndex].myAnswer = answer;
      const params = {
        examID: urlParams.id,
        questionType,
        questionID: id,
        answer
      }
      handleSubmitAnswer(params);
    }
    setQuestionList(newData);
  }

  function handleSign(firstIndex: number, secondIndex: number, flag: 0 | 1) {
    let newData = [...questionList];
    const { questionType } = newData[firstIndex];
    const { id } = newData[firstIndex].questions[secondIndex];
    newData[firstIndex].questions[secondIndex].flag = flag === 1 ? 0 : 1;
    const params = {
      examID: urlParams.id,
      questionType,
      questionID: id,
    }
    setQuestionList(newData);
    if (flag === 0) {
      addFlag(params).then((res: any) => {
        if (res && res.code === 0) {

        } else {
          res && message.error(res.msg || '标记失败！');
        }
      })
    } else {
      removeFlag(params).then((res: any) => {
        if (res && res.code === 0) {
        } else {
          res && message.error(res.msg || '标记失败！');
        }
      })
    }
  }

  function handleAnswer(firstIndex: number, secondIndex: number, data: QuestionItem) {
    let newData = [...questionList];
    newData[firstIndex].questions[secondIndex] = data;
    const { questionType } = newData[firstIndex];
    const { id } = newData[firstIndex].questions[secondIndex];
    const params = {
      examID: urlParams.id,
      questionType,
      questionID: id,
      answer: [data.myAnswer]
    };
    setQuestionList(newData);
    handleSubmitAnswer(params);
  }

  function handleSubmitAnswer(params: any) {
    submitExamAnswer(params).then((res: any) => {
      if (res && res.code === 0) {
      } else {
        res && message.error(res.msg || '提交失败');
      }
    })
  }

  return (
    <div className="content-center">
      <ul className="type-list">
        {
          questionList.map((test, index) => {
            return (
              <li className="type-list-li" key={index}>
                <div className="type-title">
                  {test.title}(共{test.questions.length}题，合计{computedCount(test.questions).toFixed(1)}分)
                </div>
                <ul className="ti-list" style={{ fontSize: textFontSize }}>
                  {
                    test.questions.map((ques, index2) => {
                      return (
                        <li className="ti-list-li" key={index2} id={ques.id}>
                          <div className="top">
                            <div><span>{index2 + 1}.</span> {ques.question}</div>
                            <div style={{ cursor: 'pointer' }} onClick={() => handleSign(index, index2, ques.flag)}>
                              {
                                ques.flag === 1 ? <FlagOutlined style={{ color: '#1DA57A' }} />
                                  : <FlagOutlined />
                              }
                            </div>

                          </div>
                          {renderOptions(index, index2, test.questionType, ques)}
                        </li>
                      )
                    })
                  }
                </ul>
              </li>
            )
          })
        }
      </ul>
    </div>
  )
}

export default QuestionList;
